<ng-template #schedulePopoverTitle>
    <fdx-popover-header titleText="Compare time zones">
    </fdx-popover-header>
</ng-template>

<ng-template #schedulePopoverContent>
    <fdx-cron-viewer
        [cron]="cron"
        [cronTimezone]="cronTimezone"
        [displaySettingsTimeZone]="true">
    </fdx-cron-viewer>
</ng-template>

<button
    type="button"
    class="btn btn-sm btn-ghost px-1"
    #spo="ngbPopover"
    [ngbPopover]="schedulePopoverContent"
    placement="bottom auto"
    [popoverTitle]="schedulePopoverTitle"
    triggers="manual"
    (click)="spo.open()">
    <fa-icon [icon]="faClockIcon"></fa-icon>
    <span>View local time</span>
</button>
